import "./styles.css";
import "./components/script-library";
import "./components/script-import-flow";
import "./components/script-player";
import "./components/app-settings";
import "./components/app-help";
import "./components/app-shell";

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => void navigator.serviceWorker.register(`${import.meta.env.BASE_URL}sw.js`));
}
